import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  // task
  "To Do": "bg-slate-100 text-slate-800 border-slate-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  "Blocked": "bg-rose-100 text-rose-800 border-rose-200",
  "Completed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  // venue / event
  "Active": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Upcoming": "bg-amber-100 text-amber-800 border-amber-200",
  "In Negotiation": "bg-amber-100 text-amber-800 border-amber-200",
  "Inactive": "bg-slate-100 text-slate-800 border-slate-200",
  "Planning": "bg-amber-100 text-amber-800 border-amber-200",
  "Registrations Open": "bg-blue-50 text-blue-700 border-blue-200",
  "Confirmed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Live": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Cancelled": "bg-rose-100 text-rose-800 border-rose-200",
  // priority
  "Low": "bg-slate-100 text-slate-700 border-slate-200",
  "Medium": "bg-blue-50 text-blue-700 border-blue-200",
  "High": "bg-amber-100 text-amber-800 border-amber-200",
  "Urgent": "bg-rose-100 text-rose-800 border-rose-200",
  // lead/sponsor
  "Lead": "bg-slate-100 text-slate-700 border-slate-200",
  "Contacted": "bg-blue-50 text-blue-700 border-blue-200",
  "Meeting Scheduled": "bg-blue-50 text-blue-700 border-blue-200",
  "Proposal Sent": "bg-amber-100 text-amber-800 border-amber-200",
  "Negotiation": "bg-amber-100 text-amber-800 border-amber-200",
  "Agreement Stage": "bg-amber-100 text-amber-800 border-amber-200",
  "Won": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Lost": "bg-rose-100 text-rose-800 border-rose-200",
  "Prospect": "bg-slate-100 text-slate-700 border-slate-200",
  "Interested": "bg-blue-50 text-blue-700 border-blue-200",
  // finance
  "Paid": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Received": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Pending": "bg-amber-100 text-amber-800 border-amber-200",
  "Partial": "bg-blue-50 text-blue-700 border-blue-200",
  "Overdue": "bg-rose-100 text-rose-800 border-rose-200",
};

export const StatusBadge = ({ status, testId }) => {
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <Badge
      data-testid={testId || `status-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`${cls} rounded-md border font-medium px-2 py-0.5 text-xs`}
    >
      {status || "—"}
    </Badge>
  );
};
